/**
 * Created by mac on 4/22/20
 */

const TileGameEditorView = EditorViewBase.extend({
    ctor: function (editor) {
        if (resolutionScale < 1) {
            throw "resolutionScale must be 1 in editor!";
        }

        this._super(editor);

        this.controlsView = this.children.find((node) => node instanceof EditorControlsView);

        const styles = cleverapps.styles.TileGameEditorView;

        const cardTableView = this.cardTableView = new EditorCardTableView(Game.currentGame.table);
        cardTableView.setPosition(this.width / 2, this.height / 2);
        this.addChild(cardTableView);
        this.addSelectionControls();

        if (typeof EditorHandView !== "undefined") {
            const handView = this.handView = new EditorHandView(Game.currentGame.hand, Game.currentGame.open, Game.currentGame.log);
            this.addChild(handView);
        }

        if (cleverapps.git) {
            const gitButtons = this.gitButtons = new GitButtonsView();
            this.addChild(gitButtons);
            gitButtons.setAlignment(styles.gitButtons);
        }

        if (cleverapps.config.type === "tile3") {
            const maxValueView = this.maxValueView = new TileColorsEditorView(Editor.currentEditor.tileColorsEditor);
            this.addChild(maxValueView);
            maxValueView.setAlignment(styles.maxValueBlock);

            const cardsCounterView = this.cardsCounterView = new CardsCounterView(Editor.currentEditor.cardsCounter);
            cardsCounterView.setAlignment(styles.cardsCounter);
            this.addChild(cardsCounterView);
        }

        const buildLayersData = () => Array.from({ length: editor.layerManager.getLayersCount() }, (_, i) => ({
            id: i,
            text: String(i),
            hidden: !editor.layerManager.isLayerVisible(i)
        }));

        const layersSwitcherView = this.layersSwitcherView = new LayersSwitcherView(buildLayersData());
        this.addChild(layersSwitcherView);
        layersSwitcherView.setAlignment(styles.layers);

        layersSwitcherView.onLayerSwitched = (layerId) => editor.setLayer(layerId);
        layersSwitcherView.onLayerVisibilityChanged = (layerId, visible) => editor.setLayerVisible(layerId, visible);

        editor.onChangeLayer = (layer) => layersSwitcherView.setLayer(layer);
        if (editor.layerManager) {
            editor.layerManager.onRebuild = layersSwitcherView.createListener(() => layersSwitcherView.rebuild(buildLayersData()));
        }

        const magicView = this.magicView = new MagicView(Editor.currentEditor.magic);
        magicView.setAlignment(styles.magic);
        this.addChild(magicView);

        const paginationView = this.paginationView = new EditorPaginationView(Game.currentGame.pagination);
        paginationView.setAlignment(styles.pagination);
        this.addChild(paginationView);
    },

    addSelectionControls: function () {
        const cardTableView = this.cardTableView;
        let startP, baseCards;

        cleverapps.UI.onDrag(this, {
            onClick: function (touch) {
                const pos = cardTableView.convertTouchToNodeSpace(touch);
                cardTableView.table.editorClicked({
                    x: pos.x,
                    y: pos.y
                });
            },

            onDragStart: function (touch) {
                const isMultiSelect = EditorCardTable.IsMultiSelectPressed();

                startP = cardTableView.convertToNodeSpace(touch.getStartLocation());
                baseCards = isMultiSelect ? cardTableView.table.selected.listSelected() : [];

                return true;
            },

            onDragMove: function (touch) {
                const current = cardTableView.convertToNodeSpace(touch.getLocation());
                const rect = cc.rect(
                    Math.min(startP.x, current.x),
                    Math.min(startP.y, current.y),
                    Math.abs(current.x - startP.x),
                    Math.abs(current.y - startP.y)
                );
                cardTableView.drawSelectionArea(rect);
                cardTableView.table.selectArea(cc.rect(rect.x - cardTableView.centerNode.x, rect.y - cardTableView.centerNode.y, rect.width, rect.height), baseCards);
            },

            onDragEnd: function () {
                if (startP) {
                    startP = undefined;
                    cardTableView.drawSelectionArea();
                }
            }
        });
    },

    getOverlappingNodes: function () {
        const scene = cleverapps.Scenes.GetRunningScene();

        return [ComponentUtils.findComponentByName(scene, "UpMenuController").node, this.controlsView, this.handView,
            this.gitButtons, this.maxValueView, this.cardsCounterView, this.layersSwitcherView, this.magicView,
            this.paginationView].filter(Boolean);
    },

    onAfterResize: function () {
        this.cardTableView.setTableScale();
    }
});

EditorView = TileGameEditorView;

cleverapps.styles.TileGameEditorView = {
    maxValueBlock: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 20 }
    },
    magic: {
        x: { align: "center", dx: 450 },
        y: { align: "bottom", dy: 40 }
    },
    cardsCounter: {
        x: { align: "center", dx: 240 },
        y: { align: "bottom", dy: 70 }
    },
    margin: 50,
    gitButtons: {
        x: { align: "right", dx: -370 },
        y: { align: "top", dy: -20 }
    },
    pagination: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: -90 }
    },
    orientation: {
        x: { align: "center", dx: -350 },
        y: { align: "top", dy: -20 }
    },
    layers: {
        x: { align: "left", dx: 70 },
        y: { align: "center", dy: -50 }
    }
};
